var render = function () {
  var _vm$formDataFormatted, _vm$formDataFormatted2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title'), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 my-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-account")]), _vm._v(" Contact Information")], 1), _c('table', {
    staticClass: "pl-2"
  }, [_c('tbody', _vm._l(_vm.formDataFormatted.info, function (d, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "font-weight-bold text-body-1 text-capitalize"
    }, [_vm._v(_vm._s(d.label))]), _c('td', [_vm._v(_vm._s(d.value))])]);
  }), 0)])]), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-multimedia")]), _vm._v("Preferred Formats")], 1), !((_vm$formDataFormatted = _vm.formDataFormatted) !== null && _vm$formDataFormatted !== void 0 && (_vm$formDataFormatted2 = _vm$formDataFormatted.formats) !== null && _vm$formDataFormatted2 !== void 0 && _vm$formDataFormatted2.length) ? _c('p', {
    staticClass: "pl-2"
  }, [_vm._v("No selection provided.")]) : _vm._l(_vm.formDataFormatted.formats, function (f) {
    return _c('v-row', {
      key: f,
      staticClass: "pl-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "font-weight-bold text-body-1 text-capitalize",
      attrs: {
        "cols": "12"
      }
    }, [_vm._v(_vm._s(f))])], 1);
  })], 2), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-star")]), _vm._v("Genre Interests")], 1), _c('table', {
    staticClass: "pl-2"
  }, [_c('tbody', _vm._l(_vm.formDataFormatted.genres, function (v, g) {
    return _c('tr', {
      key: g
    }, [_c('td', {
      staticClass: "font-weight-bold text-body-1 text-capitalize"
    }, [_vm._v(_vm._s(v.label))]), _c('td', [_vm._v(_vm._s(v.value))])]);
  }), 0)])]), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-book-heart")]), _vm._v("Favorite Titles and Authors ")], 1), _c('p', {
    staticClass: "font-weight-bold text-body-1 text-capitalize pl-2",
    domProps: {
      "innerHTML": _vm._s(_vm.formDataFormatted.questions.favorites)
    }
  })]), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-book-clock")]), _vm._v("Last Enjoyed Books ")], 1), _c('p', {
    staticClass: "font-weight-bold text-body-1 text-capitalize pl-2",
    domProps: {
      "innerHTML": _vm._s(_vm.formDataFormatted.questions.last_enjoyed)
    }
  })])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }